import {CollectionParams} from "./params/collection-params";
import {DOCUMENT_TYPES, ITEM_ID_TYPE} from "../enums/enums";
import {SEARCH_PROP_TYPES} from "../enums/e-search";
import {GO_CATEGORIES} from "../enums/e-game-objects";
import {PageParams} from "./params/page-params";
import {SearchParams} from "./params/search-params";
import {LoaderParams} from "./params/loader-params";
import {localeUtils} from "./locale-utils";


class ParamsHelper {
  constructor() {
  }


  loader() {
    return new LoaderParams();
  }


  page() {
    return new PageParams();
  }


  search() {
    return new SearchParams();
  }


  collection() {
    return new CollectionParams();
  }


  modalCollectionConfig(type: ITEM_ID_TYPE) {
    switch (type) {
      case ITEM_ID_TYPE.RESOURCE:
        return paramsHelper.collection()
          .setObjectType(DOCUMENT_TYPES.GO)
          .setDefaultListLabels()
          .setSearchParams(paramsHelper.search()
            .addNumberParam("id"))
          .setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
          .setFilterParams(paramsHelper.search()
            .addParam("category", SEARCH_PROP_TYPES.ENUM_MULTI, [GO_CATEGORIES.STUFF]));

      case ITEM_ID_TYPE.QUEST:
        return paramsHelper.collection()
          .setObjectType(DOCUMENT_TYPES.QUESTS)
          .setDefaultListLabels()
          .setItemLabelQuery(`codeName`)
          .setSearchParams(paramsHelper.search()
            .addNumberParam("id")
            .addParam(`locales.${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, "")); // todo: add filter !!?!?

      case  ITEM_ID_TYPE.OFFERS_LOTS:
        return paramsHelper.collection()
          .setObjectType(DOCUMENT_TYPES.OFFER_LOTS)
          .setDefaultListLabels()
          .setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
          .setSearchParams(paramsHelper.search()
            .addNumberParam("id")
            .addParam(`locales.${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, ""));

    }
    throw new Error(`Unknown type: ${type}`);
  }
}


export const paramsHelper = new ParamsHelper();



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/params-helper.ts